import { Client } from '../../../../models/client';
import { Workflow } from '../../../../models/workflow';
import { ContractorTypeRequirement } from '../../../../models/contractor-type-requirement';
import { ContractorTypeTag } from '../../../../models/contractor-type-tag';
import {
  Activity,
  ActivityModel,
  EmailActivity,
  FormActivity,
  PrintTemplateActivity
} from '../../../../models/activities';
import { ConditionTarget } from 'src/app/components/system/condition-builder/condition-builder.model';
import { PublishHistory } from 'src/app/services';

export type ContractorRegistrationAction = 'disable' | 'enable' | 'delete' | null;

export interface RegistrationStatusConfig {
  disableAllowed: string[];
  enableAllowed: string[];
  deleteBlocked: string[];
  renewBlocked: string[];
}

export const CONTRACTOR_STATUS_CONFIG: RegistrationStatusConfig = {
  disableAllowed: ['approved', 'denied', 'inactive', 'active'],
  enableAllowed: ['disabled'],
  deleteBlocked: ['deleted'],
  renewBlocked: ['pending', 'deleted'],
};

export interface ConfirmationModalData {
  open: boolean;
  modalDescp: string;
  modalSubDescp: string;
  yesNoBtn: boolean;
  okBtn: boolean;
  closeBtn: boolean;
  inTime: number;
  outTime: number;
}

export interface ContractorRegistrationRow {
  id: string;
  contractorId: string;
  registerApplicationId: string;
  createdApplicationId: string;
  name: string;
  businessName: string;
  registrationInfo: {
    name: string;
    business: string;
  };
  type: string;
  registrationDate: string;
  effectiveDate: string;
  expirationDate: string;
  approvedDate: string;
  status: string;
  actions: boolean;
  disabled?: boolean;
  _previousStatus?: string;
}

export class ContractorType {
  id: string;
  clientID: string;
  client: Client;
  workflowVersionId: string;
  name: string;
  description: string;

  termLength: number;

  registrationFee: string;
  renewalFee: string;
  lateFee: string;
  lateFeeStartDays: number;

  isEnabled: boolean;
  isPublished: boolean;
  visibleToPublic: boolean;
  lastPublishedOn?: Date;
  publishReason: string;

  registerWorkflowId: string;
  renewWorkflowId: string;

  registerWorkflow: Workflow;
  renewWorkflow: Workflow;

  requirements: ContractorTypeRequirement[];
  contractorTypeTags: ContractorTypeTag[];

  expirationFormulaCriteria: ConditionTarget[] | null;

  publishPage: number = 0;
  publishCount: number;
  publishPageSize: number = 10;
  publishHistory: PublishHistory[];
  publishHistoryType: 'Register' | 'Renewal';

  registerFeeActivities: { [type: string]: FormActivity };
  renewFeeActivities: { [type: string]: FormActivity };

  registerFormActivities: { [type: string]: FormActivity };
  renewFormActivities: { [type: string]: FormActivity };

  registerPrintTemplateActivities: { [id: string]: PrintTemplateActivity };
  renewPrintTemplateActivities: { [id: string]: PrintTemplateActivity };

  registerEmailActivities: { [type: string]: EmailActivity };
  renewEmailActivities: { [type: string]: EmailActivity };

  registerActivities: { [type: string]: Activity<ActivityModel> };
  renewActivities: { [type: string]: Activity<ActivityModel> };

  permissions?: any;
  availableActions?: string[];

  public constructor(options?: Partial<ContractorType>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export interface ContractorTypeSearchOptions {
  searchText?: string;
  client?: Client;
}

export interface ContractorSearchOptions {
  businessName?: string;
  contractorTypeList?: string[];
  clientId: string;
}

export interface CreateContractorType extends Partial<ContractorType> {
  name: string;
  registerWorkflowId: string;
  renewWorkflowId: string;
  visibleToPublic: boolean;
  clientID: string;
  termLength?: number;
  expirationFormulaCriteria?: ConditionTarget[] | null;
}